import { RiaUpgradeRoute } from 'types/ria';

export const riaUpgradeRouteOrder: Array<RiaUpgradeRoute> = [
	'ria-upgrade-select-investment-plan',
	'ria-upgrade-agreements',
	'ria-upgrade-success'
];
